import React from "react";
import { useJob } from "@/modules/work/jobs/context";
import { Badge } from "ui/components/badge";

export default function JobTagsSection() {
  const { tags: rawTags } = useJob();
  const tags = Array.isArray(rawTags) ? rawTags : [];

  if (tags.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-2 px-4 md:px-6">
      {tags.map((t) => {
        const tag = t?.tag ?? t;
        if (!tag?.label) return null;
        return (
          <Badge key={tag.id} variant="outline">
            {tag.label}
          </Badge>
        );
      })}
    </div>
  );
}
